module.exports = "/assets/packs/images/9a29c26082a93f141b30412c05073dac.png";